import React from 'react';

import ActivitySetupStepCollaborator from '../../components/Setup/StepCollaborator';


function ActivitySetupStepCollaboratorView() {
  return (
    <ActivitySetupStepCollaborator />
  );
}

export default ActivitySetupStepCollaboratorView;
